import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useInternalAccountActions } from 'redux/actions/internal/Accounts'

import { ApplicationState } from 'redux/Stores/types'

import {
  selectAccount,
  selectAccountNps,
  selectAccounts,
  selectAccountsFetchStatus
} from 'redux/selectors/internal/Accounts'

/** Every account of every customer, fetched if not in the store yet. */
export const useInternalAccounts = () => {
  const { tryGetAllAccounts } = useInternalAccountActions()

  const accounts = useSelector(selectAccounts)
  const fetchStatus = useSelector(selectAccountsFetchStatus)

  useEffect(() => {
    tryGetAllAccounts()
  }, [tryGetAllAccounts])

  return {
    accounts,
    error: fetchStatus === 'error',
    loading: fetchStatus === 'idle' || fetchStatus === 'fetching'
  }
}

/** One account, fetched every time the id changes. */
export const useInternalAccount = (id: string) => {
  const { tryGetOneAccount } = useInternalAccountActions()

  const account = useSelector((state: ApplicationState) =>
    selectAccount(state, id)
  )

  useEffect(() => {
    tryGetOneAccount(id)
  }, [id, tryGetOneAccount])

  return account
}

/** The account's NPS periods, fetched every time the id changes. */
export const useInternalAccountNps = (id: string) => {
  const { tryGetAccountNps } = useInternalAccountActions()

  const periods = useSelector((state: ApplicationState) =>
    selectAccountNps(state, id)
  )

  useEffect(() => {
    tryGetAccountNps(id)
  }, [id, tryGetAccountNps])

  return periods
}
